module.exports = __webpack_public_path__ + "static/media/consultancy-headline.51691962.png";